import axios from "axios";
import { BASE_URL_CUSTOMER } from "../../config/apiUrls";
import { getMasterData } from "../../config/getApiUrls";
import { Axios } from "../../config/axiosConfig";

const vehicleType = (params: any) =>
  Axios.get(BASE_URL_CUSTOMER + getMasterData(params)).catch((ex) => ex);

export default { vehicleType };
